import ApiService from '@/services/core/api.service'

const ReportService = {
  async getBookingHistories (query) {
    return ApiService.get(`user/booking-histories?${query}`)
  }
}

export default ReportService
